// extracted by mini-css-extract-plugin
module.exports = {"rentalInfoWrapper":"fZ","status":"f0","timeLeft":"f1"};